import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

import { useTranslation } from '@lt/localization';
import { getDaysDiff } from '../../../../../../utils/dateUtils';

const baseCls = 'checkout-flight-diff';

const FlightDaysDiff = ({ className, previousDate, nextDate }) => {
  const { t } = useTranslation();
  const diff = getDaysDiff(previousDate, nextDate);

  if (!diff) {
    return null;
  }

  const prefix = diff > 0 ? '+' : '';

  return (
    <sup className={cn(baseCls, className)}>{`${prefix}${diff} ${t(
      'checkout.flight.days',
    )}`}</sup>
  );
};

FlightDaysDiff.defaultProps = {
  className: null,
};

FlightDaysDiff.propTypes = {
  previousDate: PropTypes.string.isRequired,
  nextDate: PropTypes.string.isRequired,
  className: PropTypes.string,
};

export default FlightDaysDiff;
